<div class="flex flex-col gap-y-4 justify-start">
    @let isControlFilled = control().dirty && !!control().value.length;
    @if (rules().minLength) {
        @let hasError = errors()?.[FormErrorEnum.MIN_LENGTH] || !isControlFilled;
        @let text = 'passwordRules.minCharactersNumberMandatory' | transloco: { COUNT: rules().minLength };
        <ng-container
            [ngTemplateOutlet]="content"
            [ngTemplateOutletContext]="{ hasError, text }" />
    }

    @if (rules().minUppercaseCharacters) {
        @let hasError = errors()?.[FormErrorEnum.MISSING_UPPERCASE_CHARACTER] || !isControlFilled;
        @let text = 'passwordRules.uppercaseCharactersMandatory' | transloco: { COUNT: rules().minUppercaseCharacters };
        <ng-container
            [ngTemplateOutlet]="content"
            [ngTemplateOutletContext]="{ hasError, text }" />
    }

    @if (rules().minSpecialCharacters) {
        @let hasError = errors()?.[FormErrorEnum.MISSING_SPECIAL_CHARACTER] || !isControlFilled;
        @let text = 'passwordRules.specialCharactersMandatory' | transloco: { COUNT: rules().minSpecialCharacters };
        <ng-container
            [ngTemplateOutlet]="content"
            [ngTemplateOutletContext]="{ hasError, text }" />
    }

    @if (rules().minNumbers) {
        @let hasError = errors()?.[FormErrorEnum.MISSING_NUMBER] || !isControlFilled;
        @let text = 'passwordRules.numbersMandatory' | transloco: { COUNT: rules().minNumbers };
        <ng-container
            [ngTemplateOutlet]="content"
            [ngTemplateOutletContext]="{ hasError, text }" />
    }
</div>

<ng-template
    #content
    let-hasError="hasError"
    let-text="text">
    <div class="flex flex-row gap-x-2 items-center">
        @if (hasError) {
            <ng-container *ngTemplateOutlet="errorIcon" />
        } @else {
            <ng-container *ngTemplateOutlet="successIcon" />
        }
        <span>{{ text }}</span>
    </div>
</ng-template>

<ng-template #errorIcon>
    <fa-icon
        size="xl"
        [class]="isControlFilled ? 'text-error' : 'text-custom-dark-grey'"
        [icon]="['fad', 'circle-xmark']" />
</ng-template>

<ng-template #successIcon>
    <fa-icon
        size="xl"
        [class]="'text-custom-green'"
        [icon]="['fad', 'circle-check']" />
</ng-template>
